import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import "./ModalConfirmacaoExtratoSindicato.css";

export type ConcordanciaExtrato = "concorda" | "nao_concorda" | "";

export interface ModalConfirmacaoExtratoSindicatoProps {
  show: boolean;
  onClose: () => void;
  onEnviar: (concordaComValores: boolean, justificativa?: string) => void;
  enviando: boolean;
  concordancia: ConcordanciaExtrato;
  onConcordanciaChange: (value: ConcordanciaExtrato) => void;
}

const ModalConfirmacaoExtratoSindicato = ({
  show,
  onClose,
  onEnviar,
  enviando,
  concordancia,
  onConcordanciaChange,
}: ModalConfirmacaoExtratoSindicatoProps) => {
  const [justificativa, setJustificativa] = useState("");

  useEffect(() => {
    if (!show) setJustificativa("");
  }, [show]);

  useEffect(() => {
    if (concordancia === "concorda") setJustificativa("");
  }, [concordancia]);

  const podeEnviar =
    concordancia === "concorda" ||
    (concordancia === "nao_concorda" && justificativa.trim().length > 0);

  const handleEnviar = () => {
    if (!podeEnviar) return;
    onEnviar(
      concordancia === "concorda",
      concordancia === "nao_concorda" ? justificativa.trim() : undefined,
    );
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      contentClassName="modal-confirm-extract-sindicato"
    >
      <Modal.Header className="justify-content-center position-relative border-bottom">
        <Modal.Title className="modal-confirm-extract-sindicato-title">
          CONFIRMAR EXTRATO
        </Modal.Title>
        <Button
          variant="link"
          onClick={onClose}
          className="modal-confirm-extract-sindicato-close"
          aria-label="Fechar"
          disabled={enviando}
        >
          <X size={28} />
        </Button>
      </Modal.Header>

      <Modal.Body className="px-4 py-4">
        <p className="modal-confirm-extract-sindicato-text">
          Para prosseguir com o envio dos comprovantes, é necessário confirmar
          sua ciência sobre os valores apresentados no extrato.
        </p>

        <Form>
          <Form.Check
            type="radio"
            id="extrato-sindicato-concorda"
            name="concordanciaExtrato"
            label="Estou de acordo com os valores do extrato"
            checked={concordancia === "concorda"}
            onChange={() => onConcordanciaChange("concorda")}
            disabled={enviando}
            className="modal-confirm-extract-sindicato-option"
          />
          <Form.Check
            type="radio"
            id="extrato-sindicato-nao-concorda"
            name="concordanciaExtrato"
            label="Não estou de acordo com os valores do extrato"
            checked={concordancia === "nao_concorda"}
            onChange={() => onConcordanciaChange("nao_concorda")}
            disabled={enviando}
            className="modal-confirm-extract-sindicato-option"
          />

          {concordancia === "nao_concorda" && (
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Justificativa"
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
              disabled={enviando}
              className="modal-confirm-extract-sindicato-justificativa mt-2"
            />
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer className="justify-content-center border-top">
        <Button
          className="modal-confirm-extract-sindicato-enviar"
          onClick={handleEnviar}
          disabled={!podeEnviar || enviando}
        >
          {enviando ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
              Enviando...
            </>
          ) : (
            "ENVIAR"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacaoExtratoSindicato;
